
    import * as React from 'react';

    const Filter16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M3.523 2.407a1.782 1.782 0 013.485 0h8.008v.75H7.008a1.782 1.782 0 01-3.485 0H1v-.75h2.523zM9.008 7.32a1.783 1.783 0 013.486 0h2.522v.75h-2.522a1.783 1.783 0 01-3.486 0H1v-.75h8.008zm-5.485 4.913a1.783 1.783 0 013.485 0h8.008v.75H7.008a1.783 1.783 0 01-3.485 0H1v-.75h2.523z" /></svg>
        </div>
      );
    };

    Filter16.displayName = 'Filter16';

    export default Filter16;
  